import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import MuiSidebarMenu from './MuiSidebarMenu';
import MenuSkeleton from './MenuSkeleton';
import { useMenuStructure } from '../../hooks/useMenuStructure';
import { MenuItem } from '../../types';

const BeOneMenuList = ({ open }: { open: boolean }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { menuItems, loading } = useMenuStructure();

  const handleItemClick = useCallback((item: MenuItem) => {
    if (item.path) navigate(item.path);
  }, [navigate]);

  return (
    <Box sx={{ width: '100%', height: '100%', overflow: 'auto' }}>
      {loading ? (
        <MenuSkeleton />
      ) : (
        <MuiSidebarMenu
          menuItems={menuItems}
          currentPath={location.pathname}
          onItemClick={handleItemClick}
          isMenuOpen={open}
        />
      )}
    </Box>
  );
};

export default BeOneMenuList;
